<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Modifier mon profil<br/>Mares Libellules</p>
</div>

<form novalidate>
	<div class="p-3 bb">
		<?-user.getFormError()?>
		<div class="form-group">
			<?-user.getFormField('email','Adresse email',{type:'email'},{class:'fw-600 is-required'})?>
			<small class="form-text text-muted">Votre adresse email sera votre identifiant de connexion</small>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('lastname','Nom de famille',{},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('firstname','Prénom',{},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('name','Nom public / Pseudo',{},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('address','Adresse',{type:'textarea',rows:3},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('zip','Code postal',{},{class:'fw-600 is-required'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('city','Ville',{},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('phone','Téléphone',{},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('company','Structure',{},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<div class="custom-control custom-checkbox">
				<?-user.getFieldInput('config_animation',{type:'boolean'})?>
				<?-user.getFieldLabel('config_animation',"J'accepte d'être sollicité.e dans le cadre de l'animation du programme <q>Mares où êtes-vous ?</q>",{class:'custom-control-label'})?>
			</div>
		</div>
		<div class="form-group">
			<div class="custom-control custom-checkbox">
				<?-user.getFieldInput('config_complement',{type:'boolean'})?>
				<?-user.getFieldLabel('config_complement',"Je souhaite recevoir des informations complémentaires de la part des partenaires du projet",{class:'custom-control-label'})?>
			</div>
		</div>
		<div class="p-3 bb">
			<p class="text-center mb-0">
				<button type="submit" class="btn btn-lg btn-green d-block">Enregistrer les modifications</button>
			</p>
		</div>
		<div class="p-3 bb">
			<p class="text-center small text-secondary mb-0">
				<?-data.get('text_contact')?>
			</p>
		</div>
		<div class="p-3">
			<p class="text-center small text-secondary mb-0">
				<?-data.get('text_cnil')?>
			</p>
		</div>
	</div>
</form>




